module.exports = __webpack_public_path__ + "img/plug-arrow.a8f3bfbd.svg";